import { IAddressNotConfirmedUI } from './types'
import { IAddressNotConfirmedItem } from '@api/addressNotConfirmed'

import { useDeviceType } from '@hooks/useDeviceType'
import { ComponentsHeader } from '@primitive/sectionHeadings'

import imgEmty from '@img/empty.svg'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { IconAddress, IconTelegram } from '@img/icons'

import { Button, Container, Empty, Flex, Loader, Pagination, Table, ToolTip } from '@ui/index'

import css from './ui.module.scss'


const getListenerMainName = (item: IAddressNotConfirmedItem): string => `${item.lastName || ''}`.trim()
const getListenerSecondaryName = (item: IAddressNotConfirmedItem): string => `${item.firstName || ''} ${item.secondName || ''}`.trim()

const returnLogo = (dbName: string) => {
    switch (dbName) {
        case 'modern_academy': return logoModSkill
        case 'yaskill': return logoYaSkill
        default: return logoModSkill
    }
}


/** Страница - О неподтвержденных адресах */
export const AddressNotConfirmedUI = ({
    isLoading, isSending, sendingPrintID,
    txtSearch, currentPageNumber,
    items, totalCount, pageSize, weekRange,
    loadPrimaryData, txtSearchOnChange, handleOpenDelivery, handleOpenSendConfirm,
}: IAddressNotConfirmedUI) => {
    const deviceType = useDeviceType()
    const actionIconSize = deviceType === 'mobile' ? '16px' : '20px'
    const actionButtonSize = deviceType === 'mobile' ? 'xs' : 'sm'

    return <div className={css['container']}>

        <ComponentsHeader
            headerIcon={<IconAddress width="20px" height="20px" />}
            headerTitle="Адрес - не подтверждённые"
            txtSearch={txtSearch.value}
            txtSearchTooltip={<>Поиск по:<br />✓ Номеру заявки<br />✓ ФИО слушателя<br />✓ Телефону<br />✓ Email<br />✓ Номеру диплома<br />✓ Регистрационному номеру</>}
            txtSearchOnChange={(e) => txtSearchOnChange(e.target.value)}
            txtSearchClearOnClick={() => txtSearchOnChange('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch.value)}
        />

        <div className={css['week_summary']}>
            <span>Диапазон текущей недели</span>
            <b>{weekRange.monday || '--.--.----'} - {weekRange.friday || '--.--.----'}</b>
            <span>Не подтверждено: <b>{totalCount}</b></span>
        </div>

        <Table.Container>
            <Loader isOpen={isLoading} backdrop title="Загрузка неподтверждённых адресов..." />
            <Table.Header paddingLeft="50px" paddingRight="18px" classNameContainer={css['hidden_720']} classNameContent={css['table_grid_columns_header']}>
                <div style={{ textAlign: 'center' }}>
                    <p>№ заявки</p>
                    <p>№ печати</p>
                </div>
                <p>Слушатель</p>
                <div>
                    <p>Телефон</p>
                    <p>Email</p>
                </div>
                <div className={css['hidden_900']}>
                    <p>Диплом</p>
                    <p>Дата печати</p>
                </div>
                <span />
            </Table.Header>

            <Table.Content>
                {items.length === 0
                    ? <Empty image={imgEmty} title="Данные отсутствуют" />
                    : items.map((item) => (
                        <Table.Row key={item.printID} className={css['table_grid_columns_content']} onClick={() => handleOpenDelivery(item.contractID)}>
                            <img src={returnLogo(item.dataBase)} alt="Лого сайта" />

                            <div className={css['record_badge']}>
                                <p>{item.applicationID}</p>
                                <p>{item.printID}</p>
                            </div>

                            <div className={css['record_primary']}>
                                <p>{getListenerMainName(item) || '------'}</p>
                                <p className={css['record_secondary_text']}>{getListenerSecondaryName(item) || '------'}</p>
                            </div>

                            <div className={`${css['record_primary']} ${css['hidden_720']}`}>
                                <p>{item.phoneNumber || '- --- --- -- --'}</p>
                                <p className={css['record_secondary_text']}>{item.email || '------'}</p>
                            </div>

                            <div className={`${css['record_primary']} ${css['hidden_900']}`}>
                                <p>{item.diplomNumber || '------'}</p>
                                <p className={css['record_secondary_text']}>{item.datePrint || '--.--.---- --:--'}</p>
                            </div>

                            <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center" className={css['record_actions']}>
                                <ToolTip title="Отправить в Telegram канал адресов" placement="bottomRight">
                                    <Button
                                        variant="icon"
                                        size={actionButtonSize}
                                        isLoading={isSending && sendingPrintID === item.printID}
                                        isDisabled={isSending}
                                        onClick={(event) => {
                                            handleOpenSendConfirm(item)
                                            event.stopPropagation()
                                        }}
                                    >
                                        <IconTelegram width={actionIconSize} height={actionIconSize} />
                                    </Button>
                                </ToolTip>
                            </Flex>
                        </Table.Row>
                    ))
                }
            </Table.Content>
        </Table.Container>

        <Container className={css['footer']}>
            <Flex gap="4px" flexDirection="row">
                <ToolTip title="Общее количество неподтверждённых адресов" placement="topLeft">
                    <p className={css['stat_all']}>{totalCount}</p>
                </ToolTip>
            </Flex>

            <Pagination totalCount={totalCount} pageSize={pageSize} currentPage={currentPageNumber.value} onChange={(value) => currentPageNumber.setValue(value)} />
        </Container>
    </div>
}